import React from 'react';
import PropTypes from 'prop-types';
import {
	GrowableTableRowItem,
	InvisibleTableRowItem,
	Line,
	NumberColumn,
	StaticTableRowItem,
	StaticTableRowItemMultiple,
	TaskItemTableRow,
	TaskParentName,
	TimeRegPopup,
} from './task-row.styled';
import {KebabMenuIcon} from '../../util-components/menus/kebab_menu_icon';
import {BugIcon} from '../../icons/bug-icon';
import {PriorityIcon} from '../../icons/priority-icon';
import {BlockedIcon} from '../../icons/blocked-icon';
import {LabelGroup} from '../../core/label-group';
import {NOVA_INVOCATION_COLUMN_WIDTH} from '../../../forecast-app/shared/components/nova-invocation/styleTokens';

export const TaskRow = ({
	checkboxIcon,
	invocationControlIcon,
	novaUnread,
	isSelected,
	isFavoured,
	taskId,
	taskName,
	parentTaskName,
	projectName,
	clientName,
	openCardModal,
	projectIndicatorIcon,
	assigneesElement,
	ownerElement,
	statusElement,
	startDate,
	deadline,
	progress,
	phase,
	estimate,
	timeEntries,
	timeRegPopup,
	remaining,
	labels,
	starIcon,
	onContextMenu,
	contextMenuElement,
	columns,
	isBug,
	isHighPriority,
	isBlocked,
	cy,
	intl,
	noTimeReg,
	progressRegistrationPopup,
	disabled,
}) => {
	return (
		<>
			<Line data-cy={cy}>
				<TaskItemTableRow
					disabled={disabled}
					isSelected={isSelected}
					isFavoured={isFavoured}
					novaUnread={novaUnread}
					onContextMenu={!disabled && (e => (onContextMenu ? onContextMenu(e) : {}))}
				>
					{columns.checkbox && (
						<StaticTableRowItem width={18}>{checkboxIcon({checked: isSelected})}</StaticTableRowItem>
					)}
					{invocationControlIcon && (
						<StaticTableRowItem width={NOVA_INVOCATION_COLUMN_WIDTH}>{invocationControlIcon()}</StaticTableRowItem>
					)}
					{columns.projectId && (
						<StaticTableRowItem width={50} data-userpilot={'task-row-project-indicator'}>
							{projectIndicatorIcon}
						</StaticTableRowItem>
					)}
					{columns.projectName && (
						<StaticTableRowItem width={166} data-userpilot={'task-row-project-name'}>
							<span title={projectName}>{projectName}</span>
						</StaticTableRowItem>
					)}
					{columns.taskId && (
						<StaticTableRowItem width={60}>
							<a
								className={openCardModal ? 'clickable' : ''}
								data-cy="task-name"
								onKeyDown={
									openCardModal ? e => (e.key === ' ' || e.key === 'Enter' ? openCardModal(e) : null) : null
								}
								onClick={openCardModal ? e => openCardModal(e) : null}
								href={
									window.location.href + (window.location.href.endsWith('/') ? 'T' + taskId : '/T' + taskId)
								}
								tabIndex={'0'}
								title={taskName}
							>
								T{taskId}
							</a>
						</StaticTableRowItem>
					)}
					<GrowableTableRowItem>
						<div
							className={openCardModal ? 'clickable' : ''}
							data-cy="task-name"
							onKeyDown={
								openCardModal ? e => (e.key === ' ' || e.key === 'Enter' ? openCardModal(e) : null) : null
							}
							onClick={openCardModal ? e => openCardModal(e) : null}
							href={window.location.href + (window.location.href.endsWith('/') ? 'T' + taskId : '/T' + taskId)}
							tabIndex={'0'}
							title={taskName}
						>
							{parentTaskName && <TaskParentName>{parentTaskName}</TaskParentName>}
							{<PriorityIcon intl={intl} shouldShow={isHighPriority} />}
							{<BugIcon intl={intl} shouldShow={isBug} />}
							{<BlockedIcon intl={intl} shouldShow={isBlocked} />}
							{taskName}
						</div>
					</GrowableTableRowItem>
					{columns.assignedPerson && (
						<StaticTableRowItem width={166}>
							{assigneesElement ? assigneesElement : <div>Person dropdown</div>}
						</StaticTableRowItem>
					)}
					{columns.owner && (
						<StaticTableRowItem width={166}>
							{ownerElement ? ownerElement : <div>Owner Dropdown</div>}
						</StaticTableRowItem>
					)}
					{columns.client && (
						<StaticTableRowItem width={166} data-userpilot={'task-row-client'}>
							<span title={clientName}>{clientName}</span>
						</StaticTableRowItem>
					)}
					{columns.status && (
						<StaticTableRowItem width={166}>
							{statusElement ? statusElement : <div>Status dropdown</div>}
						</StaticTableRowItem>
					)}
					{columns.startDate && <StaticTableRowItem width={90}>{<span>{startDate}</span>}</StaticTableRowItem>}
					{columns.deadline && <StaticTableRowItem width={90}>{<span>{deadline}</span>}</StaticTableRowItem>}
					{columns.phase && <StaticTableRowItem width={166}>{<span title={phase}>{phase}</span>}</StaticTableRowItem>}
					{columns.progress &&
						(noTimeReg ? (
							<StaticTableRowItemMultiple width={70}>
								<TimeRegPopup>{progressRegistrationPopup}</TimeRegPopup>
								{progress}
							</StaticTableRowItemMultiple>
						) : (
							<StaticTableRowItem width={70}>
								<NumberColumn>{progress}</NumberColumn>
							</StaticTableRowItem>
						))}
					{columns.estimate && (
						<StaticTableRowItem width={60}>{<NumberColumn>{estimate}</NumberColumn>}</StaticTableRowItem>
					)}
					{columns.timeEntries && (
						<StaticTableRowItemMultiple width={80}>
							<TimeRegPopup>{timeRegPopup}</TimeRegPopup>
							{timeEntries}
						</StaticTableRowItemMultiple>
					)}
					{columns.remaining && (
						<StaticTableRowItem width={60}>{<NumberColumn>{remaining}</NumberColumn>}</StaticTableRowItem>
					)}
					{columns.labels && (
						<StaticTableRowItem width={166}>
							{<LabelGroup labels={labels} overflowStyle={'TOOLTIP'} />}
						</StaticTableRowItem>
					)}
					{columns.star && (
						<StaticTableRowItem width={14} data-userpilot={'task-row-star'}>
							{starIcon && starIcon({isFavoured: isFavoured})}
						</StaticTableRowItem>
					)}
					{onContextMenu && (
						<InvisibleTableRowItem width={16} className={'context-menu'}>
							<KebabMenuIcon onClick={e => onContextMenu(e)} disabled={disabled} />
						</InvisibleTableRowItem>
					)}
					<InvisibleTableRowItem width={14} />
				</TaskItemTableRow>
			</Line>
			{!disabled && contextMenuElement && contextMenuElement()}
		</>
	);
};

TaskRow.propTypes = {
	intl: PropTypes.shape({
		formatMessage: PropTypes.func,
	}),

	/**
	 * The checkbox icon from web-components, optionally wrapped in another component
	 */
	checkboxIcon: PropTypes.func.isRequired,

	/**
	 * Renders the Nova invocation control for this row, next to the checkbox. Omitted entirely
	 * (not just hidden) on surfaces that don't opt in.
	 */
	invocationControlIcon: PropTypes.func,

	/**
	 * Tints the whole row when this task has a completed Nova run nobody has opened yet.
	 * Clears once the run's output has been read.
	 */
	novaUnread: PropTypes.bool,

	/**
	 * Toggles selected visual on row
	 */
	isSelected: PropTypes.bool,

	/**
	 * Task favourit status
	 */
	isFavoured: PropTypes.bool,

	/**
	 * The star icon from web-components, optionally wrapped in another component
	 */
	starIcon: PropTypes.func,

	/**
	 * Company Task id
	 */
	taskId: PropTypes.number.isRequired,

	/**
	 * Name of the task
	 */
	taskName: PropTypes.string.isRequired,

	/**
	 * Name of the parent task (Using task hierarchy)
	 */
	parentTaskName: PropTypes.string,

	/**
	 * Name of the project
	 */
	projectName: PropTypes.string.isRequired,

	/**
	 * Name of the client attached to the project
	 */
	clientName: PropTypes.string,

	/**
	 * Function used to open the Task Modal
	 */
	openCardModal: PropTypes.func,

	/**
	 * Project IndicatorIcon from web-components, optionally wrapped in another component
	 */
	projectIndicatorIcon: PropTypes.func.isRequired,

	/**
	 *    Dropdown containing the status of the task
	 */
	statusElement: PropTypes.func,

	/**
	 *    Dropdown for the assignees of the task
	 */
	assigneesElement: PropTypes.func,

	/**
	 *    Dropdown for the owners of the task
	 */
	ownerElement: PropTypes.func,

	/**
	 * Phase name of the task
	 */
	phase: PropTypes.string,

	/**
	 * Start date of the task, in the format "10 May"
	 */
	startDate: PropTypes.any,

	/**
	 * Deadline of the task, in the format "10 May"
	 */
	deadline: PropTypes.any,

	/**
	 * Progress of the task as percentage
	 */
	progress: PropTypes.string,

	/**
	 * Remaining time of the task, in time format
	 */
	remaining: PropTypes.string,

	/**
	 * Time estimated for the task, in time format
	 */
	estimate: PropTypes.string,

	/**
	 * Time registered on the task, in time format
	 */
	timeEntries: PropTypes.string,

	/**
	 * Pop op next to the time entries to add time to the task
	 */
	timeRegPopup: PropTypes.node,

	/**
	 * An array of label definitions
	 */
	labels: PropTypes.arrayOf(
		PropTypes.shape({
			/**
			 * The name of the label, which is also displayed as text
			 */
			name: PropTypes.string.isRequired,

			/**
			 * The color of the label. Text color will be the inverse of this
			 */
			color: PropTypes.string.isRequired,
		})
	),

	/**
	 * Function to open the context menu
	 */
	onContextMenu: PropTypes.func,

	/**
	 * Context menu
	 */
	contextMenuElement: PropTypes.func,

	/**
	 * Elements to show (or not) in the row
	 */
	columns: PropTypes.shape({
		checkbox: PropTypes.bool,
		projectId: PropTypes.bool,
		projectName: PropTypes.bool,
		taskId: PropTypes.bool,
		assignedPerson: PropTypes.bool,
		owner: PropTypes.bool,
		client: PropTypes.bool,
		status: PropTypes.bool,
		startDate: PropTypes.bool,
		deadline: PropTypes.bool,
		phase: PropTypes.bool,
		progress: PropTypes.bool,
		estimate: PropTypes.bool,
		timeEntries: PropTypes.bool,
		remaining: PropTypes.bool,
		labels: PropTypes.bool,
		star: PropTypes.bool,
	}).isRequired,

	/**
	 * Task indicator: bug
	 */
	isBug: PropTypes.bool,
	/**
	 * Task indicator:high priority
	 */
	isHighPriority: PropTypes.bool,
	/**
	 * Task indicator: blocked
	 */
	isBlocked: PropTypes.bool,

	/**
	 * Cypress data information
	 */
	cy: PropTypes.string,

	/**
	 * Determin wheter or not the user has no time registration enabled
	 * If true, no time registration is enabled
	 */
	noTimeReg: PropTypes.bool,

	/**
	 * Popup for entering progress for a task where time registration is not used
	 */
	progressRegistrationPopup: PropTypes.node,

	/**
	 * Disables the row
	 */
	disabled: PropTypes.bool,
};

TaskRow.defaultProps = {
	intl: {
		formatMessage: ({id}) => id,
	},
	openCardModal: () => false,
};
